import * as React from 'react'
import TenantView from 'Components/templates/TenantView'
import {useForm, useFormContext} from "react-hook-form";
import {useLocation, useParams} from 'react-router'
import {TENANT_MOCK_DATA} from "Constants/mockedData/tenant";
import GoToTop from "Components/molecules/GoToTop";

export default function TenantViewScreen() {
  // const {reset} = useFormContext();
  // const location = useLocation();
  // const params = useParams();
  // const { register, getValues } = useForm();
  //
  // React.useEffect(async () => {
  //   await reset(TENANT_MOCK_DATA)
  //   console.log('Screen::TenantView: ', getValues())
  //   return  () => reset()
  // }, [])

  return (
      <>
        {/*<GoToTop />*/}
        <TenantView />
      </>

  )
}
